import { render, staticRenderFns } from "./grafico.vue?vue&type=template&id=53506efc"
import script from "./grafico.ts?vue&type=script&lang=js&external"
export * from "./grafico.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53506efc')) {
      api.createRecord('53506efc', component.options)
    } else {
      api.reload('53506efc', component.options)
    }
    module.hot.accept("./grafico.vue?vue&type=template&id=53506efc", function () {
      api.rerender('53506efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/formafarmaceutica/grafico.vue"
export default component.exports